import urls from '../../../modules/urls'
import { LOCATION } from '../../../modules/vars'
import useAppRouter from './useAppRouter'

export const useGoToPreviousPage = (page, isPast) => {
  const router = useAppRouter()

  // 새탭으로 열린 경우
  const toPreviousPage = () => {
    // 다른 탭에서 새창으로 열린 경우
    if (document.referrer) {
      console.log(document.referrer, 'document.referrer')
      switch (page) {
        case LOCATION.REVIEW:
          // 복습 상세 -> 복습 목록
          router.push(urls.student.portal.lessons.review)
          break

        case LOCATION.PREP:
          if (isPast) {
            // 복습 | 예습내역 -> 복습 (시간으로 구분)
            router.push(urls.student.portal.lessons.review)
          } else {
            // 예습 상세 -> 예습 목록
            router.push(urls.student.portal.lessons.upcomingLessons)
          }
          break

        case LOCATION.LESSON:
          // 수업 상세 -> (수업전) 예습 목록
          if (isPast) {
            router.push(urls.student.portal.lessons.upcomingLessons)
          } else {
            //  (수업후) 수업 평가 모달
            return
          }
          break
        case LOCATION.COURSE:
          router.push(urls.student.newPortal.materials.list)
          break
      }
    }
    // 기존 탭에서 열린 경우
    else window.history.back()
  }
  return toPreviousPage
}
